import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-white border-t-3 border-text pt-16 pb-8" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-41">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-42">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-43">
              <span className="text-4xl" data-id="element-44">🐾</span>
              <span className="font-display font-black text-2xl tracking-tight" data-id="element-45">
                Patitas Felices
              </span>
            </a>
            <p className="font-medium text-gray-600 text-center md:text-left max-w-xs" data-id="element-46">
              Clínica veterinaria urbana. Cuidamos a tu mascota como si fuera
              nuestra.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-47">
            <h4 className="font-black text-xl mb-4" data-id="element-48">Enlaces Rápidos</h4>
            <ul className="space-y-2 font-bold text-gray-700 text-center md:text-left" data-id="element-49">
              <li data-id="element-50">
                <a href="#servicios" className="hover:text-primary transition-colors" data-id="element-51">
                  Servicios
                </a>
              </li>
              <li data-id="element-52">
                <a href="#equipo" className="hover:text-primary transition-colors" data-id="element-53">
                  Nuestro Equipo
                </a>
              </li>
              <li data-id="element-54">
                <a href="#testimonios" className="hover:text-primary transition-colors" data-id="element-55">
                  Testimonios
                </a>
              </li>
              <li data-id="element-56">
                <a href="#contacto" className="hover:text-primary transition-colors" data-id="element-57">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Social Placeholder */}
          <div className="flex flex-col items-center md:items-start" data-id="element-58">
            <h4 className="font-black text-xl mb-4" data-id="element-59">Seguinos</h4>
            <div className="flex gap-4" data-id="element-60">
              {['📸', '📘', '🎵'].map((icon, i) => <a key={i} href="#" className="bg-bg border-2 border-text rounded-full w-12 h-12 flex items-center justify-center text-xl neo-shadow-sm hover:bg-primary transition-colors transform hover:-translate-y-1" data-id="element-61">
                  {icon}
                </a>)}
            </div>
          </div>
        </div>

        <div className="border-t-2 border-text pt-8 text-center font-bold text-gray-500" data-id="element-62">
          <p data-id="element-63">
            © {new Date().getFullYear()} Patitas Felices. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
};